import { createSelector } from 'reselect';
import { RootState } from '../store';

const selectDetailsState = (state: RootState) => state.details;

export const selectLoading = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.loading
);

export const selectError = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.error
);

export const selectDetailsData = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.data
);

export const selectFeeCode = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.feeCode
);

export const selectFeeDescription = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.feeDescription
);

export const selectSubFee = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.subFee
);

export const selectAmountHistory = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.amountHistory
);

export const selectDescriptionHistory = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.descriptionHistory
);

export const selectAmountHistoryExist = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.amountHistory.length > 0
);

export const selectDescriptionHistoryExist = createSelector(
    selectDetailsState,
    (detailsState) => detailsState.descriptionHistory.length > 0
);